import _ from "lodash";

export const getClientCounsellors = (appointments) => _.uniq(_.flatMap(appointments, "calendar"))
